import React from 'react';

export default ({ icon:Icon = null, bold=false, dark=false, children, className, ...props }) => <div className={`zt-event-buy__add-friends__infoblock ${dark?'zt-event-buy__add-friends__infoblock--dark' :''} ${className ? className : ''}`}>
    {Icon && <Icon className='zt-event-buy__add-friends__infoblock__icon'/>}
    <span className={`zt-nav ${bold?'':'light'}`}>{children}</span>
</div>